<template lang="pug">
	.stars-container
		.stars(v-if="!onlyCount")
			span(v-for="step of maxScore")
				<svg :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" alt="" v-if="parsedScore >= step" v-html="starRatingFull">
				</svg>
				<svg :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg"  alt="" v-if="(Number.isNaN(parsedScore)) || (step > parsedScore && step - parsedScore != 0.5)" v-html="starRatingEmpty">
				</svg>
				<svg :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" alt="" v-if="step - parsedScore == 0.5" v-html="starRatingHalf">
				</svg>
		.score(v-if="showCount && parsedScore > 0" :class="{'no-stars': onlyCount}")
			span.strong
				| {{ parsedScore }}
			| &nbsp;/ {{ maxScore }}
		.score.black(v-if="showCount && (!parsedScore || score == 'N/A')" :class="{'no-stars': onlyCount}")
			| N/A


</template>

<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'
	.stars-container
		@media (max-width: 1010px)
			display: flex
			align-items: center
		.stars
			min-width: max-content!important
			display: inline-block
			@media (max-width: 369px)
				width: 100%
				text-align: right
			@media (min-width: 370px) and (max-width: 1010px)
				width: 60%
				text-align: left
			span
				width: 24px
				height: 24px
				display: inline-block
				position: relative
				margin-right: 4px
				@media (max-width: 1010px)
					width: 17px
					width: 17px
					top: -3px
		.score
			display: block
			font-size: body-font-size-md
			line-height: body-font-line-heigth-xs
			color: gray-50
			margin-top: 8px
			.strong
				font-weight: body-font-weight-strong
				color: body-font-color-black
			@media (max-width: 369px)
				display: none
			&.black
				color: body-font-color-black
			&.no-stars
				margin-top: 0 !important
				@media (max-width: 369px)
					display: block
			@media (max-width: 1010px)
				width: 40%
				text-align: right
				margin-top: 0px
</style>

<script>
export default {
	props: {
		score: {
			type: [Number, String],
			default: 0
		},
		maxScore: {
			type: Number,
			default: 5
		},
		width: {
			type: [Number, String],
			default: 24
		},
		height: {
			type: [Number, String],
			default: 24
		},
		showCount:{
			type: Boolean,
			default: true
		},
		onlyCount:{
			type: Boolean,
			default: false
		}
	},
	data() {
		const starRatingFull = `
			<g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd"> <g fill="#FCBD34"> <g> <g> <g> <g> <g> <g> <path d="M11.999 0c-.22 0-.414.143-.48.353L8.916 8.785H.5c-.214 0-.405.136-.474.34-.07.202-.001.427.17.557L7.026 14.9l-2.611 8.454c-.065.208.013.433.19.557.088.06.188.09.288.09.107 0 .214-.034.304-.104l6.802-5.196 6.802 5.196c.09.07.197.104.304.104.1 0 .2-.03.287-.09.178-.124.256-.349.19-.557l-2.61-8.454 6.81-5.203c.132-.09.218-.24.218-.41 0-.277-.222-.5-.498-.5h-8.419L12.478.352c-.065-.21-.26-.353-.48-.353" transform="translate(-564 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(168) translate(0 30) translate(56)"/> </g> </g> </g> </g> </g> </g> </g> </g>
		`
		const starRatingEmpty = `
			<defs xmlns="http://www.w3.org/2000/svg"> <path id="3floiwvsga" d="M0 0H12V24H0z"/> <path id="ti9pdvflpc" d="M11.999 0c-.22 0-.414.143-.48.353L8.916 8.785H.5c-.214 0-.405.136-.474.34-.07.202-.001.427.17.557L7.026 14.9l-2.611 8.454c-.065.208.013.433.19.557.088.06.188.09.288.09.107 0 .214-.034.304-.104l6.802-5.196 6.802 5.196c.09.07.197.104.304.104.1 0 .2-.03.287-.09.178-.124.256-.349.19-.557l-2.61-8.454 6.81-5.203c.132-.09.218-.24.218-.41 0-.277-.222-.5-.498-.5h-8.419L12.478.352c-.065-.21-.26-.353-.48-.353"/> <path id="hgkpgow8ed" d="M0 0H12V24H0z"/> <path id="m6p0f0zq9f" d="M11.999 0c-.22 0-.414.143-.48.353L8.916 8.785H.5c-.214 0-.405.136-.474.34-.07.202-.001.427.17.557L7.026 14.9l-2.611 8.454c-.065.208.013.433.19.557.088.06.188.09.288.09.107 0 .214-.034.304-.104l6.802-5.196 6.802 5.196c.09.07.197.104.304.104.1 0 .2-.03.287-.09.178-.124.256-.349.19-.557l-2.61-8.454 6.81-5.203c.132-.09.218-.24.218-.41 0-.277-.222-.5-.498-.5h-8.419L12.478.352c-.065-.21-.26-.353-.48-.353"/> </defs> <g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd" opacity=".5"> <g> <g> <g> <g> <g> <g> <g> <g transform="translate(-620 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(168) translate(0 30) translate(112)"> <mask id="w4ryyomapb" fill="#fff"> <use xlink:href="#3floiwvsga" xmlns:xlink="http://www.w3.org/1999/xlink"/> </mask> <g mask="url(#w4ryyomapb)"> <use fill="#979797" xlink:href="#ti9pdvflpc" xmlns:xlink="http://www.w3.org/1999/xlink"/> </g> </g> <g transform="translate(-620 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(168) translate(0 30) translate(112) translate(12)"> <mask id="cagpyifsqe" fill="#fff"> <use xlink:href="#hgkpgow8ed" xmlns:xlink="http://www.w3.org/1999/xlink"/> </mask> <g mask="url(#cagpyifsqe)"> <g transform="translate(-12)"> <use fill="#979797" xlink:href="#m6p0f0zq9f" xmlns:xlink="http://www.w3.org/1999/xlink"/> </g> </g> </g> </g> </g> </g> </g> </g> </g> </g> </g>
		`
		const starRatingHalf = `
			<defs xmlns="http://www.w3.org/2000/svg"> <path id="z54fztnkya" d="M0 0H12V24H0z"/> <path id="uojs3rvnfc" d="M11.999 0c-.22 0-.414.143-.48.353L8.916 8.785H.5c-.214 0-.405.136-.474.34-.07.202-.001.427.17.557L7.026 14.9l-2.611 8.454c-.065.208.013.433.19.557.088.06.188.09.288.09.107 0 .214-.034.304-.104l6.802-5.196 6.802 5.196c.09.07.197.104.304.104.1 0 .2-.03.287-.09.178-.124.256-.349.19-.557l-2.61-8.454 6.81-5.203c.132-.09.218-.24.218-.41 0-.277-.222-.5-.498-.5h-8.419L12.478.352c-.065-.21-.26-.353-.48-.353"/> <path id="ry27sa0lnd" d="M0 0H12V24H0z"/> <path id="3kgvolermf" d="M11.999 0c-.22 0-.414.143-.48.353L8.916 8.785H.5c-.214 0-.405.136-.474.34-.07.202-.001.427.17.557L7.026 14.9l-2.611 8.454c-.065.208.013.433.19.557.088.06.188.09.288.09.107 0 .214-.034.304-.104l6.802-5.196 6.802 5.196c.09.07.197.104.304.104.1 0 .2-.03.287-.09.178-.124.256-.349.19-.557l-2.61-8.454 6.81-5.203c.132-.09.218-.24.218-.41 0-.277-.222-.5-.498-.5h-8.419L12.478.352c-.065-.21-.26-.353-.48-.353"/> </defs> <g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd"> <g> <g> <g> <g> <g> <g> <g> <g transform="translate(-592 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(168) translate(0 30) translate(84)"> <mask id="wiye6duipb" fill="#fff"> <use xlink:href="#z54fztnkya" xmlns:xlink="http://www.w3.org/1999/xlink"/> </mask> <g mask="url(#wiye6duipb)"> <use fill="#FCBD34" xlink:href="#uojs3rvnfc" xmlns:xlink="http://www.w3.org/1999/xlink"/> </g> </g> <g opacity=".5" transform="translate(-592 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(168) translate(0 30) translate(84) translate(12)"> <mask id="n3kk9x88be" fill="#fff"> <use xlink:href="#ry27sa0lnd" xmlns:xlink="http://www.w3.org/1999/xlink"/> </mask> <g mask="url(#n3kk9x88be)"> <g transform="translate(-12)"> <use fill="#979797" xlink:href="#3kgvolermf" xmlns:xlink="http://www.w3.org/1999/xlink"/> </g> </g> </g> </g> </g> </g> </g> </g> </g> </g> </g>
		`
		return {
			starRatingFull,
			starRatingEmpty,
			starRatingHalf
		}
	},
	computed: {
		parsedScore(){
			return parseFloat(this.score)
		}
	}
}
</script>

